/* @flow */

import { callLiferayEndpoint } from './index';

import utils from './utils';

import type { Category } from 'types';

const find = async (): Promise<Category[]> => {
  const response = await callLiferayEndpoint('/protones-portlet.categorie/find-all', {});
  return response.map(utils.toCategory);
};

export default {
  find,
};
